import { Button, Input } from "antd";
import type { ReactNode } from "react";
import { defaultTheme } from "@/runtime/config";
import EmblemImage from "../../../../old-console-ui/src/assets/images/emblem.png";

/** 更新密码/邮箱共用旧版 main/container/footer 页面骨架。 */
export function SafeSettingFormShell({ children }: { children: ReactNode }) {
    return <section className="update-password-page"><main className="update-password-main"><div className="update-password-container">{children}</div></main><footer className="update-password-footer"><div>{defaultTheme.copyright}</div><div>{defaultTheme.icpFilings}</div>{defaultTheme.internetFilings ? <div><img src={EmblemImage} alt="国徽" />{defaultTheme.internetFilings}</div> : null}</footer></section>;
}

/** 更新密码/邮箱共用旧版验证码输入与 102px 发送按钮。 */
export function SafeCaptchaInput({ value, onChange, countdown, onSend, placeholder = "请输入验证码" }: { value?: string; onChange?: (value: string) => void; countdown: number; onSend: () => void; placeholder?: string }) {
    return <div className="update-password-captcha"><Input value={value} onChange={event => onChange?.(event.target.value)} placeholder={placeholder} /><Button type="primary" onClick={onSend}>{countdown ? `${countdown}秒重新获取` : "发送验证码"}</Button></div>;
}
